import React, { useContext } from 'react'
import { useGetUser } from '../../../api/auth/useGetUser'
import { useGetCurrencies } from '../../../api/utils/useGetCurrencies'
import Dividends from './Dividends'
import Stocks from './Stocks'
import Currency from './Currency'
import { NavigationTabs } from '../../../components/NavigationTabs'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import DateRangePicker from '../../../components/DatePickers/DateRangePicker'
import { DateRangeContext } from '../../../context/DateRangeProvider'

const Home = (): JSX.Element => {
  const { data: user } = useGetUser()
  const { data: currencies } = useGetCurrencies()
  const { dateRange, setDateRange } = useContext(DateRangeContext)

  return (
    <div
      className={
        'w-full min-h-screen px-4 sm:px-10 py-8 bg-foreground/10 dark:bg-slate-800'
      }>
      <div className="flex flex-row justify-between items-center mb-4 ">
        <div className="text-2xl font-bold text-foreground">Overview</div>
        <div>
          <DateRangePicker filters={dateRange} onChange={(date) => setDateRange(date)} />
        </div>
      </div>
      <NavigationTabs
        tabs={[
          {
            name: 'Dividends',
            path: 'dividends',
          },
          {
            name: 'Stocks',
            path: 'stocks',
          },
          {
            name: 'Currency',
            path: 'currency',
          },
        ]}
      />
      <Routes>
        <Route
          path="dividends"
          element={<Dividends user={user} currencies={currencies} />}
        />
        <Route path="stocks" element={<Stocks user={user} currencies={currencies} />} />
        <Route
          path="currency"
          element={<Currency user={user} currencies={currencies} />}
        />
        <Route path="*" element={<Navigate to={'dividends'} />} />
      </Routes>
      <Outlet />
    </div>
  )
}

export default Home
